import * as React from "react"
import { useContext, useEffect, useState } from "react";
import { getShapeImages, shapes, CUSTOM_IMAGE_SHAPE } from "./ShapeItems";
import { Context } from "../../../../Context/context";
import { ShapeItem, ShapeSetting } from "../../../../TypesAndConstants/types";

interface SliderItemProp {
    sliderItem: ShapeItem,
    index: number,
    setShape: ( slideterItem: ShapeItem  ) => void;
}
function SliderItem ({ sliderItem, setShape, index }: SliderItemProp ) {
  return ( 
      <span
        key={ index }
        id={"mobileShape_"+index}
        style={{
          border: "2px solid black",
          padding: "10px",
          margin: "10px",
        }}
      >
        <div
          key={sliderItem.shape}
          onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            setShape(sliderItem);
            event.preventDefault();
            return false;
          }}
          style={{
            height: "50px",
            width: "50px",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url("${sliderItem.url}")`,
          }}
        />
      </span>
    );
};


export default function ShapeGallery( ){
  const {
    state: {
      shapeImages,
      images,
      shapeSettings
    },
    dispatch,
  } = useContext(Context);
  const [ imageItems, setImageItems ] = useState<ShapeItem[]>([]);
  
  const setShape = ( sliderItem: ShapeItem ):void => {
    const shape: ShapeSetting = {
      shape: sliderItem.shape,
      imageIndex: sliderItem.imageIndex,
      shapeSize: shapeSettings.shapeSize,
      shapeRotation: shapeSettings.shapeRotation,
    };
    dispatch({ type: "set_shape", value: shape });
  };


  useEffect(()=> {
    setImageItems( getShapeImages(shapeImages, images) );
  }, [images])

  return (
    <div
      style={{
        margin: "10px",
        display: "flex",
        flexWrap: "wrap",
        maxHeight: "45vh",
        overflow: "auto",
      }}
    >
      { imageItems.map((item, index) => <SliderItem key={index} sliderItem={item} index={ ( CUSTOM_IMAGE_SHAPE + index) } setShape={ setShape } /> )  }
      { shapes.map( (item, index ) => <SliderItem key={(100 + index)}sliderItem={item} index={item.shape} setShape={ setShape } /> )  }
    </div>
  );
};
